// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__6ZWdA","links_container":"NavBar_links_container__jx4-Q","navbar_item":"NavBar_navbar_item__FJ+c1","navbar_link":"NavBar_navbar_link__t7crm"};